import feedbacks, { epics as feedbackEpics } from './feedbacks';

export const epics = [
  ...feedbackEpics,
];

export default feedbacks;
